<template>
	<div class="widget">
		<iframe :src="endpoint" />
	</div>
</template>

<script>
export default {
    name: 'WidgetView',
	props: {
		widget: Object
	},
	data () {
		return {
			endpoint: null
		}
	},
	mounted () {

		const url = new URL(this.widget.settings.url)
		const path = 'https://www.youtube.com/embed/'
		const id = url.searchParams.get('v')
		const loop = this.widget.settings.loop ? '&loop=1' : '&loop=0'
		const modestBranding = this.widget.settings.modestBranding ? '&modestBranding=1' : '&modestBranding=0'
		const mute = this.widget.settings.mute ? '&mute=1' : '&mute=0'

		this.endpoint = `${path}${id}?controls=0&autoplay=1${modestBranding}${mute}${loop}`

	}
}
</script>

<style lang="scss" scoped>
.widget {

	height: 100%;
	position: relative;
	width: 100%;

	iframe {
		border: 0;
		height: 100%;
		width: 100%;
	}

}
</style>
